import { TrustedBrowsersState } from '@shared/redux/state/trustedBrowsersState';
import { RequestState } from '@shared/constants/request';

export const initialTrustedBrowsersState: TrustedBrowsersState = {
  entities: [],
  gettingRequestState: RequestState.NOT_STARTED,
  deletionRequestState: RequestState.NOT_STARTED,
};
